module.exports = {
    // basic
    'a-company-to-view-templates': 'a company to view templates',
    'templates': 'templates',
    'template': 'template',
    'rejection-reason': 'rejection reason',

    // raw
    // template
};
